<template>
    <v-row no-gutters>
        <v-col
            lg="6"
            offset-lg="3"
            md="12"
        >
            <v-progress-linear
                v-if="loading"
                indeterminate
                color="primary"
            />
            <v-row>
                <v-col cols="12">
                    <v-skeleton-loader
                        v-if="loading"
                        class="mx-auto"
                        type="card"
                    />
                    <div
                        v-if="!loading"
                        class="headline mb-3"
                        v-text="$t('page.participant.registration_information')"
                    />
                    <RegistrationInformation
                        v-if="!loading"
                        :data="data"
                        :errors="errors"
                    />
                </v-col>
                <v-col cols="12">
                    <v-skeleton-loader
                        v-if="loading"
                        class="mx-auto"
                        type="card"
                    />
                    <div
                        v-if="!loading"
                        class="headline mb-3"
                        v-text="$t('page.participant.personal_information')"
                    />
                    <PersonalInformation
                        v-if="!loading"
                        :data="data"
                        :errors="errors"
                    />
                </v-col>
                <v-col cols="12">
                    <v-skeleton-loader
                        v-if="loading"
                        class="mx-auto"
                        type="card"
                    />
                    <div
                        v-if="!loading"
                        class="headline mb-3 mt-9"
                        v-text="$t('page.participant.job_information')"
                    />
                    <JobInformation
                        v-if="!loading"
                        :data="data"
                        :errors="errors"
                    />
                </v-col>
                <v-col cols="12">
                    <v-skeleton-loader
                        v-if="loading"
                        class="mx-auto"
                        type="card"
                    />
                    <div
                        v-if="!loading"
                        class="headline mb-3 mt-9"
                        v-text="$t('page.participant.rav_information')"
                    />
                    <RAVALVInformation
                        v-if="!loading"
                        :data="data"
                        :errors="errors"
                    />
                </v-col>
                <v-col cols="12">
                    <v-skeleton-loader
                        v-if="loading"
                        class="mx-auto"
                        type="card"
                    />
                    <div
                        v-if="!loading"
                        class="headline mb-3 mt-9"
                        v-text="$t('page.participant.course_information')"
                    />
                    <CourseInformation
                        v-if="!loading"
                        :data="data"
                        :errors="errors"
                    />
                </v-col>
                <v-col cols="12">
                    <v-skeleton-loader
                        v-if="loading"
                        class="mx-auto"
                        type="card"
                    />
                    <div
                        v-if="!loading"
                        class="headline mb-3 mt-9"
                        v-text="$t('page.participant.presence_information')"
                    />
                    <PresenceInformation
                        v-if="!loading"
                        :data="data"
                        :errors="errors"
                    />
                </v-col>
            </v-row>
            <UnsavedForm
                :unsaved-form="unsavedForm"
                :errors="errors"
                :on-save="saveFunction"
                :on-cancel="cancelObjectChanges"
            />
        </v-col>
    </v-row>
</template>

<style lang="scss">
.action-fab {
    position: fixed;
    top: 80%;
    left: 72%;
    z-index: 10;
}
</style>

<script>
import UnsavedForm from '@/components/common/UnsavedForm';
import PersonalInformation from '@/components/participants/Form/PersonalInformation';
import RegistrationInformation from '@/components/registrations/Form/RegistrationInformation';
import JobInformation from '@/components/participants/Form/JobInformation';
import RAVALVInformation from '@/components/participants/Form/RAVALVInformation';
import CourseInformation from '@/components/participants/Form/CourseInformation';
import PresenceInformation from '@/components/participants/Form/PresenceInformation';
import { DefaultSnackbar } from '@/app-events.js';

export default {
    name: 'ParticipantForm',
    components: {
        UnsavedForm,
        PersonalInformation,
        RegistrationInformation,
        JobInformation,
        RAVALVInformation,
        CourseInformation,
        PresenceInformation,
    },
    props: {
        rawData: {
            type: Object,
            default: () => ({}),
        },
        data: {
            type: Object,
            default: () => ({}),
        },
        errors: {
            type: Object,
            default: () => ({}),
        },
        loading: {
            type: Boolean,
            default: false,
        },
        saveFunction: {
            type: Function,
            default: () => ({}),
        },
        discardFunction: {
            type: Function,
            default: () => ({}),
        },
    },
    data() {
        return {
            unsavedForm: false,
        }
    },
    methods: {
        cancelObjectChanges() {
            this.$eventBus.dispatch(new DefaultSnackbar(this.$t('general.changes_discarded')));
            this.discardFunction();
        },
    },
    watch: {
        data: {
            handler(_, oldValue) {
                if (JSON.stringify(this.data) === JSON.stringify(this.rawData)) {
                    this.unsavedForm = false;
                } else {
                    this.unsavedForm = true;
                }
            },
            deep: true
        },
        rawData: {
            handler(_, oldValue) {
                if (JSON.stringify(this.data) === JSON.stringify(this.rawData)) {
                    this.unsavedForm = false;
                } else {
                    this.unsavedForm = true;
                }
            },
            deep: true
        },
    }
};
</script>
